import React, { useEffect, useState } from "react";
import { isNullOrUndefined } from "../../../../../common/utils";
import {
  AuthZTable,
  defaultPageSize,
  defaultPageSizeOptions,
} from "../../../../../components/authZTable";
import { UserTableColumnGenerator } from "../../../../../components/InfoTab/UsersTable/userTableColumnGenerator";
import "./index.css";
import {
  sendUserGroupDetailsEvent,
  UserGroupDetailsAction,
} from "../../../../../components/matomoClient";

const InitialPage = 1;

function AsyncUsersTable({
  dispatchCallBack,
  loading,
  dataSource,
  columns,
  totalElements,
  individualInclusions,
  tableId,
  mainApiRequestData,
  error,
  rowClassName
}) {
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [page, setPage] = useState(InitialPage);

  let modifiedColumns = UserTableColumnGenerator(columns, individualInclusions, false, false);
  function onPageChange(current) {
    setPage(current);
  }

  function changePageSize(size) {
    setPageSize(size);
  }

  useEffect(() => {
    dispatchCallBack(page, pageSize);
  }, [page, pageSize]);

  useEffect(() => {
    dispatchCallBack(InitialPage, pageSize);
    setPage(InitialPage);
    sendUserGroupDetailsEvent(
      UserGroupDetailsAction.SearchMembersByCondition,
      "Add members by key condition"
    );
  }, [JSON.stringify(mainApiRequestData)]);

  return (
    <>
      {isNullOrUndefined(error) ? (
        <AuthZTable
          className="async-users-table"
          loading={loading}
          dataSource={dataSource}
          columns={modifiedColumns}
          id={tableId}
          rowKey={"key"}
          pagination={{
            showSizeChanger: true,
            showQuickJumper: true,
            pageSize: pageSize,
            pageSizeOptions: defaultPageSizeOptions,
            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
            current: page,
            total: totalElements,
            onShowSizeChange: (current, pageSize) => changePageSize(pageSize, current),
            onChange: (current) => onPageChange(current),
          }}
          rowClassName={rowClassName}
        />
      ) : (
        <div className="error-text">Error fetching details</div>
      )}
    </>
  );
}

export default AsyncUsersTable;
